import { useSelector } from "react-redux";
import { CustomMetadataFieldType } from "types";
import { getSelectedQueryModal } from "redux/SingleDataset/selectors";
import { isCustomMetadata } from "helpers/utility/customMetadataHelpers";

import EnumModal from "./EnumModal";
import LinkModal from "./LinkModal";
import NumberModal from "./NumberModal";
import StringModal from "./StringModal";
import DateTimeModal from "./DateTimeModal";

interface CustomMetadataQueryModalProps {
  editQueryId?: string;
}

export default function CustomMetadataQueryModal({
  editQueryId,
}: CustomMetadataQueryModalProps) {
  const selectedQueryModalData = useSelector((state) =>
    getSelectedQueryModal(state)
  );

  const modalType = selectedQueryModalData?.type;
  const field = isCustomMetadata(modalType) ? modalType : null;

  if (!field) {
    return <noscript />;
  }

  const { field_type } = field;

  const modalMap: Record<CustomMetadataFieldType, JSX.Element> = {
    datetime: <DateTimeModal editQueryId={editQueryId} field={field} />,
    string: <StringModal editQueryId={editQueryId} field={field} />,
    float: <NumberModal editQueryId={editQueryId} field={field} />,
    enum: <EnumModal editQueryId={editQueryId} field={field} />,
    link: <LinkModal editQueryId={editQueryId} field={field} />,

    //not handled yet
    geolocation: <noscript />,
  };

  return modalMap[field_type];
}
